import styled from 'styled-components';

export const UiAccountPage = styled.div`
	display: block;
`;